import { Button, TablePagination } from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { useQuery } from "@tanstack/react-query";
import * as React from "react";
import { getScheduleTypes } from "../../api/schedule_types";
import ScheduleTypeEdit from "../../components/Chief/ScheduleTypeEdit";

export default function ScheduleTypeList(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const { data, refetch } = useQuery({
    queryKey: ["scheduleTypes", page, rowsPerPage],
    queryFn: () => getScheduleTypes(rowsPerPage, page * rowsPerPage),
    throwOnError: true,
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [open, setOpen] = React.useState(false);
  const [rowData, setRowData] = React.useState(null);

  const handleClickOpen = (row) => {
    setRowData(row);
    setOpen(true);
  };

  const handleClose = async () => {
    setOpen(false);
    await refetch();
  };

  return (
    <Box
      sx={{
        position: "relative;",
        width: "100%",
        height: "100%",
      }}
    >
      <TableContainer component={Paper}>
        <Box
          sx={{
            margin: "12px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">スケジュール分類</Typography>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "8px 16px",
              width: "115px",
              height: "40px",
              background: "#21456A",
              /* elevation/2 */
              boxShadow:
                "0px 1px 5px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2)",
              borderRadius: "6px",
            }}
            onClick={() => handleClickOpen(null)}
          >
            ＋&nbsp;新規登録
          </Button>
          <ScheduleTypeEdit
            isNew={rowData === null}
            obj={rowData}
            open={open}
            onClose={handleClose}
          />
        </Box>
        <Table sx={{ minWidth: 300 }}>
          <TableHead>
            <TableRow>
              <TableCell align="left">名称</TableCell>
              <TableCell align="left">説明</TableCell>
              <TableCell align="left" sx={{ width: 100 }}>
                操作
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.results?.map((row) => (
              <TableRow
                key={row.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell align="left">{row.description}</TableCell>
                <TableCell align="left">
                  <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "8px 16px",
                      width: "62px",
                      height: "40px",
                      background: "#21456A",
                      /* elevation/2 */
                      boxShadow:
                        "0px 1px 5px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2)",
                      borderRadius: "6px",
                    }}
                    onClick={() => handleClickOpen(row)}
                  >
                    編集
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[3, 10, 25]}
        component="div"
        count={data && (data.count ?? 0)}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
}
